import CONSTANTS from '../constants'
import { downloadFile, getRequest, postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'

export const getSessionDetails = (promoObj) => (dispatch) => {
  // if(pageload) {
  //   dispatch({ type: CONSTANTS.SESSION_EVENT_REQUEST })
  // }
  dispatch(addEventLog(promoObj, CONSTANTS.APPLY_PROMOCODE_REQUEST))
  dispatch({ type: CONSTANTS.APPLY_PROMOCODE_REQUEST })
  return postRequest(APICONFIG.getSessionDetails, promoObj).then((res) => {
    let resObject = { ...promoObj, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.APPLY_PROMOCODE_SUCCESS))
    dispatch({ type: CONSTANTS.APPLY_PROMOCODE_SUCCESS, data: res, 'promocode': promoObj.promo ? true : false })
    localStorage.setItem('paymentSession', res?.data ? JSON.stringify(res?.data) : '{}')
    return { 'data': res?.data, 'promocode': promoObj.promo ? true : false }
  }).catch((err) => {
    let errObject = { ...promoObj, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.APPLY_PROMOCODE_FAILURE))
    dispatch({ type: CONSTANTS.APPLY_PROMOCODE_FAILURE })
    // if(pageload) {
    //   dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
    // }
    return err
  })
}
export const getDefaultSession = (defaultSession) => (dispatch) => {
  dispatch(addEventLog(defaultSession, CONSTANTS.APPLY_PROMOCODE_REQUEST))
  dispatch({ type: CONSTANTS.APPLY_PROMOCODE_REQUEST })
  return postRequest(APICONFIG.getSessionDetails, defaultSession).then((res) => {
    let resObject = { ...defaultSession, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.APPLY_PROMOCODE_SUCCESS))
    dispatch({ type: CONSTANTS.APPLY_PROMOCODE_SUCCESS, data: res })
    localStorage.setItem('paymentSession', res?.data ? JSON.stringify(res?.data) : '{}')
    return { 'data': res?.data }
  }).catch((err) => {
    let errObject = { ...defaultSession, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.APPLY_PROMOCODE_FAILURE))
    dispatch({ type: CONSTANTS.APPLY_PROMOCODE_FAILURE })
    return err
  })
}

//UPDATE PROMOCODE USAGE DETAILS
export const updatePromoCodeUsageDetails = (postData) => (dispatch) => {
  dispatch(addEventLog(postData, CONSTANTS.GET_PROMOCODE_USAGE_REQUEST))
  dispatch({ type: CONSTANTS.GET_PROMOCODE_USAGE_REQUEST })
  return postRequest(APICONFIG.getPromoCodeUsage, postData).then((res) => {
    let resObject = { ...postData, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.GET_PROMOCODE_USAGE_SUCCESS))
    dispatch({ type: CONSTANTS.GET_PROMOCODE_USAGE_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...postData, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.GET_PROMOCODE_USAGE_FAILURE))
    dispatch({ type: CONSTANTS.GET_PROMOCODE_USAGE_FAILURE })
  })
}

// Calls the API to booking before payment
export const saveBookingBeforePayment = (postData) => (dispatch) => {
  dispatch(addEventLog(postData, CONSTANTS.BEFORE_PAYMENT_INITIAL_REQUEST))
  dispatch({ type: CONSTANTS.BEFORE_PAYMENT_INITIAL_REQUEST })
  return postRequest(APICONFIG.saveBookingBeforePaymentUrl, postData).then((res) => {
    let resObject = { ...postData, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.BEFORE_PAYMENT_INITIAL_SUCCESS))
    dispatch({ type: CONSTANTS.BEFORE_PAYMENT_INITIAL_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...postData, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.BEFORE_PAYMENT_INITIAL_FAILURE))
    dispatch({ type: CONSTANTS.BEFORE_PAYMENT_INITIAL_FAILURE })
    return err
  })
}


// Calls the API to booking before payment
export const saveBookingAfterPayment = (postData) => (dispatch) => {
  dispatch(addEventLog(postData, CONSTANTS.AFTER_PAYMENT_INITIAL_REQUEST))
  dispatch({ type: CONSTANTS.AFTER_PAYMENT_INITIAL_REQUEST })
  return postRequest(APICONFIG.saveBookingafterPaymentUrl, postData).then((res) => {
    let resObject = { ...postData, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.AFTER_PAYMENT_INITIAL_SUCCESS))
    dispatch({ type: CONSTANTS.AFTER_PAYMENT_INITIAL_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...postData, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.AFTER_PAYMENT_INITIAL_FAILURE))
    dispatch({ type: CONSTANTS.AFTER_PAYMENT_INITIAL_FAILURE })
    return err
  })
}
export const downloadQrcodeRequest = (postData, pdfName, setPromoLoader) => (dispatch) => {
  dispatch({ type: CONSTANTS.QRCODE_REQUEST })
  let endpoint = `${APICONFIG.downloadQrcodeRequestUrl}/${postData}`
  return downloadFile(endpoint, `${pdfName}.pdf`, setPromoLoader)
}
export const downloadPassQrcodeRequest = (postData, pdfName, setPromoLoader) => (dispatch) => {
  dispatch({ type: CONSTANTS.QRCODE_REQUEST })
  let endpoint = `${APICONFIG.downloadPassQrcodeRequestUrl}/${postData}`
  return downloadFile(endpoint, `${pdfName}.pdf`, setPromoLoader)
}


// new payment gate way API 
export const dynamicPaymentGateByNonce = (postData) => (dispatch) => {
  dispatch(addEventLog(postData, CONSTANTS.NONCE_TYPE_PAYMENT_REQUEST))
  dispatch({ type: CONSTANTS.NONCE_TYPE_PAYMENT_REQUEST })
  return postRequest(APICONFIG.noncePaymentGateway, postData).then((res) => {
    let resObject = { ...postData, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.NONCE_TYPE_PAYMENT_SUCCESS))
    dispatch({ type: CONSTANTS.NONCE_TYPE_PAYMENT_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...postData, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.NONCE_TYPE_PAYMENT_FAILURE))
    dispatch({ type: CONSTANTS.NONCE_TYPE_PAYMENT_FAILURE })
    return err
  })
}


// Calls the API to get Facility Initials
export const getCardDataList = () => (dispatch) => {
  dispatch({ type: CONSTANTS.GET_CARD_LIST_REQUEST })
  let endpoint = `${APICONFIG.getCardDataUrl}`
  return getRequest(endpoint).then((res) => {
    dispatch({ type: CONSTANTS.GET_CARD_LIST_SUCCESS, data: res?.data?.payments })
    return res
  }).catch(() => {
    dispatch({ type: CONSTANTS.GET_CARD_LIST_FAILURE })
  })
}

// GET VEHICLE LIST DETAILS
export const getVehicleDataList = () => (dispatch) => {
  dispatch(addEventLog('', CONSTANTS.GET_VEHICLE_LIST_REQUEST))
  dispatch({ type: CONSTANTS.GET_VEHICLE_LIST_REQUEST })
  return getRequest(`${APICONFIG.getVehicleListUrl}/page/1`).then((res) => {
    let resObject = res
    dispatch(addEventLog(resObject, CONSTANTS.GET_VEHICLE_LIST_SUCCESS))
    dispatch({ type: CONSTANTS.GET_VEHICLE_LIST_SUCCESS, data: res.data })
    return res.data
  }).catch((err) => {
    let errObject = err
    dispatch(addEventLog(errObject, CONSTANTS.GET_VEHICLE_LIST_FAILURE))
    dispatch({ type: CONSTANTS.GET_VEHICLE_LIST_FAILURE })
    return err
  })
}

export const getVehicleModelList = (countryCode = '', countryId = '') => (dispatch) => {
  const payload = {
    countryCode: countryCode,
    countryId: countryId
  }
  dispatch(addEventLog(payload, CONSTANTS.GET_VEHICLE_MODEL_REQUEST))
  let apiUrls = `${APICONFIG.getVehicleModelUrl}`
  if (countryId && countryId != '') {
    apiUrls = `${APICONFIG.getVehicleModelUrl}/${countryId}`
  }
  dispatch({ type: CONSTANTS.GET_VEHICLE_MODEL_REQUEST })
  return getRequest(`${apiUrls}`).then((res) => {
    let resObject = { ...payload, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.GET_VEHICLE_MODEL_SUCCESS))
    dispatch({ type: CONSTANTS.GET_VEHICLE_MODEL_SUCCESS, data: res.data })
    return res.data
  }).catch((error) => {
    let errObject = { ...payload, ...error }
    dispatch(addEventLog(errObject, CONSTANTS.GET_VEHICLE_MODEL_FAILURE))
    dispatch({ type: CONSTANTS.GET_VEHICLE_MODEL_FAILURE })
    return error
  })
}

export const downloadPass = (account_number = '', appleWalletApi = '') => async (dispatch) => {
  dispatch({ type: CONSTANTS.PASS_DOWNLOAD_REQUEST })

  // API URL with query parameter
  const apiUrl = `${appleWalletApi}?account_number=${account_number}`

  try {
    const response = await fetch(apiUrl)
    const contentType = response.headers.get('content-type')

    if (contentType && contentType.includes('application/json')) {
      const errorData = await response.json()
      dispatch({ type: CONSTANTS.PASS_DOWNLOAD_FAILURE, payload: errorData })
      return Promise.reject(errorData) // Ensure error data is passed to `.catch()`
    }

    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url
    a.download = `pass-${account_number}.pkpass`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)

    dispatch({ type: CONSTANTS.PASS_DOWNLOAD_SUCCESS })
    return Promise.resolve()
  } catch (err) {
    dispatch({ type: CONSTANTS.PASS_DOWNLOAD_FAILURE, payload: err })
    return Promise.reject(err)
  }
}

export const downloadGooglePass = (account_number = '', googleWalletApi = '') => (dispatch) => {
  dispatch({ type: CONSTANTS.PASS_DOWNLOAD_REQUEST })
  // API URL with query parameter
  const apiUrl = `${googleWalletApi}?account_number=${account_number}`

  return getRequest(apiUrl).then((res) => {
    dispatch({ type: CONSTANTS.PASS_DOWNLOAD_SUCCESS, data: res })

    // Handle the URL response
    // Option 1: Open the URL in a new tab
    window.open(res, '_blank')

    // Option 2: Create a temporary link and trigger click
    const a = document.createElement('a')
    a.href = res
    a.target = '_blank' // Open in new tab
    document.body.appendChild(a)
    a.click()
    a.remove()
    return res
  }).catch((err) => {
    dispatch({ type: CONSTANTS.PASS_DOWNLOAD_FAILURE })
    return err
  })
}